import { getProfessionalCampaigns } from './GetProfessionalCampaigns';
import { getCampaigns } from './GetCampaigns';
import { getCampaign } from './GetCampaign';
import { getCampaignReport } from './GetCampaignReport';
import { getCampaignTargetOffices } from './GetCampaignTargetOffices';
import { getOfficeDiscountHistory } from './GetOfficeDiscountHistory';

export const CampaignsApi = {
  getProfessionalCampaigns,
  getCampaigns,
  getCampaign,
  getCampaignReport,
  getCampaignTargetOffices,
  getOfficeDiscountHistory,
};

export { CAMPAIGNS_ENDPOINT, CAMPAIGNS_MAX_LIMIT } from './GetCampaigns';
